import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext();
const KEY = "eg_compare";

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const has = (slug) => items.some((i) => i.slug === slug);

  const toggle = (product) => {
    setItems((prev) => {
      if (prev.some((i) => i.slug === product.slug)) {
        return prev.filter((i) => i.slug !== product.slug);
      }
      if (prev.length >= 4) {
        toast.error("You can compare up to 4 bikes");
        return prev;
      }
      toast.success("Added to comparison");
      return [...prev, {
        slug: product.slug, name: product.name, price: product.sale_price || product.price,
        thumbnail: product.thumbnail, category: product.category, specs: product.specs, rating: product.rating,
      }];
    });
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);

  return (
    <CompareContext.Provider value={{ items, has, toggle, remove, clear, count: items.length }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
